import React from "react";

import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Modal as BootstrapModal } from "react-bootstrap";
import styled from "styled-components";

import { useAppState } from "../../../contexts/ApplicationStateProvider";
import { useStores } from "../../../contexts/StoreContext";
import Icon from "../../Icon/Icon";
import Vacancy from "./Vacancy";

const StyledTopBar = styled.div`
  color: #fff;
  min-height: 4rem;
  background-color: ${({ theme, inversed }) =>
    inversed ? "#fff" : theme.primaryColor};
`;

function VacancyModal(props) {
  const { thumbnailUrl } = props;
  const { modalStore } = useStores();
  const { closeModal } = modalStore;
  const { isMobile } = useAppState();

  return (
    <>
      <StyledTopBar
        className="w-100 d-flex align-items-center ps-4"
        onClick={closeModal}
      >
        <Icon className="me-4" icon="chevronLeft" size={20} />
        <span> BACK TO RESULTS LIST</span>
      </StyledTopBar>
      <BootstrapModal.Body className="px-4">
        <Vacancy modalMode={isMobile} thumbnailUrl={thumbnailUrl} />
      </BootstrapModal.Body>
    </>
  );
}

VacancyModal.defaultProps = {
  thumbnailUrl: null,
};

VacancyModal.propTypes = {
  thumbnailUrl: PropTypes.string,
};

export default observer(VacancyModal);
